/*
 * @Author: yuehui
 * @Date: 2019-08-05 16:59:56
 * @LastEditTime: 2019-11-11 17:44:22
 * @LastEditors: yuehui
 * @Description: 基础接口1
 */
import {
  buildGiftCode,
  getGiftInfo,
  confirmGiftInfo
} from '@/api/gift'

const state = {
}

const mutations = {
}

const actions = {
  // v-1.1.0-01-生成到店礼品码
  buildGiftCode(temp, data) {
    return new Promise((resolve, reject) => {
      buildGiftCode(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // v-1.1.0-02-获取礼品信息
  getGiftInfo(temp, data) {
    return new Promise((resolve, reject) => {
      getGiftInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // v-1.1.0-03-确认领取礼品
  confirmGiftInfo(temp, data) {
    return new Promise((resolve, reject) => {
      confirmGiftInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
